import React, { useEffect, useState, FormEvent } from "react";
import "./Header.scss";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
//  cookie functions
import { withTranslation, useTranslation } from "react-i18next";
// svg icons
import IMAGES from "../../assets/images";
import IconButton from "@material-ui/core/IconButton";
import useMediaQuery from "@material-ui/core/useMediaQuery";
// import Redux
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/reducers";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import sunmilogo  from "../../assets/images/sunmilogo.svg"


function Header(props: any) {
  const minDesktop = useMediaQuery("(min-width: 992px)");
  const state = useSelector((state: RootState) => state.waiter);
  const dispatch = useDispatch();
  const { langValueState } = bindActionCreators(actionCreators, dispatch);
  const navigate = useNavigate();
  const { userFor, callingFrom } = props


  // const arLanguageHandle = (e) => {
  //   appDispatch({
  //     type: "LangChange",
  //     langValue: "ar",
  //   });
  // };
  // const enLanguageHandle = (e) => {
  //   appDispatch({
  //     type: "LangChange",
  //     langValue: "en",
  //   });
  // };


  return (
    <>
      <div className={`${callingFrom ? "ScanQrCode" : "HeaderParent"}  py-1 align-items-center d-flex justify-content-between`} >

        {/* {!minDesktop && userFor == undefined ? <img src={IMAGES.enabillJan} alt="enabill-logo" className="mx-4" /> : ""} */}


        {!userFor && callingFrom == "ScanQrCode" ? <img src={sunmilogo} alt="enabill-logo" className="mx-4 enabillsunmi" /> : !userFor ? <img src={IMAGES.enabillLogo} alt="enabill-logo" className="mx-4" /> : ""}


        {userFor == "InvoiceData" && <>
          <span>
            <IconButton
              onClick={() => navigate(-1)}
              className="mx-2"
            >
              {state.langValue === "ar" ? <KeyboardArrowRightIcon /> : <KeyboardArrowLeftIcon />}


            </IconButton>
          </span>

          <img src={IMAGES.enabillLogo} alt="enabill-logo" className="mx-4" />

        </>}




        {state.langValue === "ar" ? <IconButton
          className="arabicBtn mx-2 my-2"
          onClick={() => langValueState("en")}
        >
          <span className="">EN</span>
        </IconButton> : <IconButton
          className="arabicBtn mx-2 my-2"
          onClick={() => langValueState("ar")}
        >
          <span className="mb-2">عربي</span>
        </IconButton>}



      </div>
    </>
  );
}
export default withTranslation()(Header);
